export default {
  search: "",
  list: [],
  page: 1,
  limit: 10,
  counter: {
    total: 0,
    week: 0,
    month: 0
  }
};
